import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SidebarInfocardComponent } from './sidebar-infocard.component';

@NgModule({
	declarations: [SidebarInfocardComponent],
	imports: [
		CommonModule,
	],
	exports: [SidebarInfocardComponent],
})
export class SidebarInfocardModule { }
